/** Authoritative product capability registry (version-controlled; review at release). */
export const PLATFORM_CAPABILITIES = [
    {
        id: 'copilot.assistant',
        name: 'Copilot / Assistent',
        status: 'live',
        description: 'Chat-assistent voor platformuitleg en read-only projectanalyse.',
        featureFlag: 'copilot_v1',
        docsRefs: ['fo-copilot-assistent', 'adr-010-copilot-orchestration'],
        introducedAt: '2026-10',
    },
    {
        id: 'copilot.read_tools',
        name: 'Copilot read-only project tools',
        status: 'live',
        description: 'Campagnes, doelgroepen, GA4/GSC snapshots via tools.',
        featureFlag: 'copilot_read_tools_v1',
        introducedAt: '2026-10',
    },
    {
        id: 'audiences.segments',
        name: 'Doelgroepen & segmenten',
        status: 'live',
        description: 'Statische/dynamische doelgroepen, segment engine, KPI.',
        featureFlag: 'audiences_v1',
        docsRefs: ['doelgroepen-README'],
        introducedAt: '2026-10',
    },
    {
        id: 'campaign.sequences',
        name: 'Campagnes & sequences',
        status: 'live',
        description: 'Outbound sequences, enrollment, send rails.',
        docsRefs: ['fo-campagnes-en-automation'],
    },
    {
        id: 'campaign.step_experiments',
        name: 'Step-level A/B varianten',
        status: 'live',
        description: 'Varianten per sequence-stap.',
        featureFlag: 'step_experiments_v1',
        docsRefs: ['fo-campaign-step-variants'],
    },
    {
        id: 'campaign.metrics_v2',
        name: 'Campagne KPI v2',
        status: 'partial',
        description: 'Reply-definitie en metrics v2; rollout via flag.',
        featureFlag: 'campaign_metrics_v2',
        docsRefs: ['fo-metrics-system-of-record'],
    },
    {
        id: 'mail.reply_classification',
        name: 'Reply-classificatie',
        status: 'live',
        description: 'Regels + AI classificatie op inbound replies.',
        featureFlag: 'reply_classification_v1',
    },
    {
        id: 'mail.reply_classification_actions',
        name: 'Reply-classificatie automatische acties',
        status: 'partial',
        description: 'Side effects na classificatie; standaard shadow/off.',
        featureFlag: 'reply_classification_actions_v1',
    },
    {
        id: 'automations.runtime',
        name: 'Automations & agents',
        status: 'live',
        description: 'Automation runs, pg-boss, run_agent/draft_reply steps.',
        featureFlag: 'automations_v1',
        docsRefs: ['ai-agents-automations'],
    },
    {
        id: 'scraper.acquisition',
        name: 'Scraper (lead acquisition)',
        status: 'partial',
        description: 'Scrape jobs, candidates, approve/reject; beta flag.',
        featureFlag: 'scraper_beta',
        docsRefs: ['scraper-README'],
    },
    {
        id: 'integrations.ga4',
        name: 'Google Analytics 4 integratie',
        status: 'live',
        description: 'Dagelijkse GA4 snapshot sync.',
    },
    {
        id: 'integrations.gsc',
        name: 'Google Search Console integratie',
        status: 'live',
        description: 'Dagelijkse GSC snapshot sync.',
    },
    {
        id: 'integrations.brevo',
        name: 'Brevo integratie',
        status: 'live',
        description: 'OAuth, lists, broadcast sync.',
    },
    {
        id: 'integrations.wordpress',
        name: 'WordPress integratie',
        status: 'live',
        description: 'Content sync snapshots.',
    },
    {
        id: 'analytics.experimental',
        name: 'Analytics experimenteel',
        status: 'partial',
        featureFlag: 'analytics_experimental',
        description: 'Experimentele analytics UI/API.',
    },
    {
        id: 'copilot.plans_execute',
        name: 'Copilot plannen & goedkeuren',
        status: 'planned',
        description: 'Wizard, copilot_plans, execute na approval.',
        docsRefs: ['adr-010-copilot-orchestration', 'fo-copilot-assistent'],
    },
    {
        id: 'copilot.strategy_wizard',
        name: 'Copilot strategy / campagne wizard',
        status: 'planned',
        description: 'Structured marketing plans; geen live execute in Fase 1.',
        docsRefs: ['fo-copilot-assistent'],
    },
    {
        id: 'ui.automation_builder_hitl',
        name: 'Automation builder & HITL queue',
        status: 'partial',
        description: 'UI-3 builder, draft approval queue — deels gap.',
        docsRefs: ['35-fase-ui-3-automations-hitl'],
    },
    {
        id: 'feature.nonexistent_example',
        name: 'Intern eval placeholder',
        status: 'unknown',
        description: 'Niet in productregistry; gebruikt voor eval-tests.',
    },
];
const byId = new Map(PLATFORM_CAPABILITIES.map((c) => [c.id, c]));
export function getPlatformCapability(id) {
    return byId.get(id);
}
export function listPlatformCapabilities() {
    return [...PLATFORM_CAPABILITIES];
}
//# sourceMappingURL=capabilities.js.map